import Head from "../components/head-data/head-data"
import VisitorHome from "../components/visitor-home/visitor-home"
import FounderAssistPage from "./founder-assist"

// Visitors get the pitch: find a co-founder, then build with a plan. Members
// land on their FounderAssist dashboard; the ideas feed lives at /ideas and
// messages in the header (docs/hero-redesign-plan.md §4).
const Home = (props) => {
  if (props.me) return <FounderAssistPage {...props} />
  return (
    <div className="visitor-home">
      <Head
        title="FounderCloud | Find a Co-founder, Then Build With a Plan"
        description="Find a co-founder with the skills you're missing, then build together with a weekly plan from FounderAssist. Free to join."
        url="https://www.foundercloud.com"
      />
      <VisitorHome />
    </div>
  )
}

export default Home
